<template>
  <div class="AddGroupManage">
    <van-nav-bar
      title="添加群管理员"
      fixed
      @click-left="onClickLeft"
      right-text="确定"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="manage">
      <van-checkbox class="all" v-model="checked" type="info" @click="toggleAll">全选</van-checkbox>
      <van-checkbox-group v-model="result" ref="checkboxGroup">
        <van-checkbox
          :name="item.u_id"
          v-for="(item,index) in groupmemberInfo"
          :key="index+'a'"
          v-if="item.u_id != u_id"
        >
          <van-cell
            border
            :title="item.pivot.ug_group_nick?item.pivot.ug_group_nick:item.f_name.f_name?item.f_name.f_name:item.u_nickname?item.u_nickname:item.u_login_id"
          >
            <van-image
              slot="icon"
              class="err-image-header"
              round
              :src="attach_url+item.u_headportrait"
            />
          </van-cell>
        </van-checkbox>
      </van-checkbox-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddGroupManage",
  data() {
    return {
      ug_id: "",
      groupmemberInfo: "",
      checked: false,
      result: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_id: this.ug_id,
        token: this.token,
        u_id: this.u_id,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Groups/getGroupUserInfoById";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("cccc",response);
          if (response.data.code == 200) {
            this.groupmemberInfo = response.data.result[0].group_user;
          }
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "ShowGroupManage",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    onClickRight() {
      var params = {
        ug_group_id: this.ug_id,
        // groupName: this.groupName,
        token: this.token,
        u_id: this.u_id,
        ug_user_id: this.result
      };
      // console.log(this.result);
      var url = this.Conf.serverUrl + "Groups/setGroupManage";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("hhhhh", response);
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              this.onClickLeft();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    },
    // 全选
    toggleAll() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        this.$refs.checkboxGroup.toggleAll(true);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Group/AddGroupManage.vue